import { render, staticRenderFns } from "./Zadaci.vue?vue&type=template&id=9d760fb6&"
import script from "./Zadaci.vue?vue&type=script&lang=js&"
export * from "./Zadaci.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports